var _linearGradient, _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTailwind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 700 512",
    width: 700,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "objectBoundingBox",
    x2: 1,
    y1: -0.889,
    y2: 1.889
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2383ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6dd7b9"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h700v512h-700z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m179.9 157.625q34.5-138.109 172.607-138.109c138.109 0 155.338 103.532 224.373 120.821q69.055 17.278 120.82-51.766-34.5 138.079-172.586 138.089c-138.114 0-155.338-103.533-224.373-120.821q-69.054-17.278-120.821 51.766zm-172.606 207.144q34.557-138.109 172.606-138.109c138.109 0 155.338 103.532 224.373 120.821q69.054 17.278 120.821-51.766-34.494 138.108-172.606 138.108c-138.109 0-155.338-103.532-224.373-120.821q-69.055-17.278-120.821 51.767z",
    fill: "url(#a)",
    fillRule: "evenodd",
    transform: "translate(2.299 29.484)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwind);
export default __webpack_public_path__ + "static/media/tailwind.8b7508c1ea8498c9f23537f86942e95c.svg";
export { ForwardRef as ReactComponent };